import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    MyDate
} from "src/components/common/functions";

const title = "Personnel";
export default function Export({
    filterUserList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const curUser = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filterUserList.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = `${curUser.userName}`;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filterUserList.map(post => [
            post.userName,
            post.email, 
            post.phoneNumber, 
            post.workPhone, 
            post.extension, 
            post.region, 
            post.department, 
            post.role, 
            //------------
            post.unionName, 
            post.phaseLevel,
            post.hireDate?new Date(post.hireDate.replace(/-/g, "/")):"",  
            post.quitDate?new Date(post.quitDate.replace(/-/g, "/")):"", 
            post.ssn,
            post.birthDay ?? "",
            post.googleAccount,
            post.creator,
            post.dateCreated?new Date(post.dateCreated?.replace(/-/g, "/")):"", 
            post.updater,
            post.dateUpdated?new Date(post.dateUpdated?.replace(/-/g, "/")):"", 
            //------------
            post.projects,
            post.workLogs,
            post.purchases,
            post.perDiem,
            post.newspaper,
            post.fleets,
            post.reports,
            post.personel,
            post.calendar,
            post.dayOff,
            post.office,
            post.allOffice,
            post.outside,
            post.outsideTimeCards,
            post.outsideStatus,
            //------------
            post.background
        ])
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "User Name", filterButton: true},
                { name: "Email Address", filterButton: true},
                { name: "Mobile Phone", filterButton: true},
                { name: "Work Phone", filterButton: true},
                { name: "Office Extension", filterButton: true},
                { name: "Region", filterButton: true},
                { name: "Department", filterButton: true},
                { name: "Role", filterButton: true},
                //-------------------------------
                { name: "Union Name", filterButton: true},
                { name: "Phase Level", filterButton: true},
                { name: "Hire Date", filterButton: true},
                { name: "Quit Date", filterButton: true},
                { name: "SSN", filterButton: true},
                { name: "Birthday", filterButton: true},
                { name: "Google Account", filterButton: true},
                { name: "Creator Name", filterButton: true},
                { name: "Date Created", filterButton: true},
                { name: "Updater Name", filterButton: true},
                { name: "Date Updated", filterButton: true},
                //-------------------------------
                { name: "Projects", filterButton: true},
                { name: "Work Logs", filterButton: true},
                { name: "Purchase", filterButton: true},
                { name: "Per Diem", filterButton: true},
                { name: "Newspaper", filterButton: true},
                { name: "Fleets", filterButton: true},
                { name: "Reports", filterButton: true},
                { name: title, filterButton: true},
                { name: "Calendar", filterButton: true},
                { name: "Time Off", filterButton: true},
                { name: "Office", filterButton: true},
                { name: "Office Status", filterButton: true},
                { name: "Outside Service", filterButton: true},
                { name: "Outside Service Timecards", filterButton: true},
                { name: "Outside Service Status", filterButton: true},
                //-------------------------------
                { name: "Background", filterButton: true},
            ],
            rows: rows,
        });
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // exclude row 1 ----------
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `personnel export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return (
        <span className = "pointer" onClick = {exportFunc}>
            Export
        </span>
    )
}